// extracted by mini-css-extract-plugin
export default {"list":"TerritoryColorKey_list__+3oTD"};